export default ($page) => {
    return [
        {
            route: 'tools.activity-logs.index',
            label: 'messages.sitemap.tools.activity_logs.activity_logs',
            showInSidebar: true,
            permissions: ['tool.activity_log'],
            id: 'tools-activity-logs-index'
        },
        {
            route: 'tools.communications.index',
            label: 'messages.sitemap.tools.communications.communications',
            showInSidebar: true,
            permissions: ['communication.view'],
            id: 'tools-proba-index'
        },
        ...($page.props.modules.antagonist_da
            ? [
                {
                    route: 'tools.direct-admin.index',
                    label: 'messages.sitemap.tools.direct_admin.direct_admin',
                    showInSidebar: true,
                    id: 'tools-direct-admin-index'
                }
            ]
            : []
        ),
        {
            route: 'tools.fulfillment.support-links.index',
            label: 'messages.sitemap.tools.fulfillment.fulfillment',
            showInSidebar: true,
            permissions: ['support_links.generic'],
            id: 'tools-fulfillment-support-links-index'
        },
        {
            route: '',
            label: 'messages.sitemap.tools.templates',
            showInSidebar: true,
            permissions: ['tool.emails', 'tool.emails_edit', 'tool.documents', 'setting.sms'],
            showSecondDropdown: true,
            sidebarItemName: 'emails',
            id: 'tools-emails',
            children: [
                {
                    route: 'tools.documents.index',
                    label: 'messages.sitemap.tools.documents.documents',
                    showInSidebar: true,
                    permissions: ['tool.documents'],
                    id: 'tools-documents-index'
                },
                {
                    route: 'tools.emails.index',
                    label: 'messages.sitemap.tools.emails.overview',
                    permissions: ['tool.emails'],
                    showInSidebar: true,
                    id: 'tools-emails-index',
                    children: [
                        {
                            route: 'tools.emails.editor.index',
                            label: 'messages.sitemap.tools.emails.editor.index',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-editor-index'
                        },
                        {
                            route: 'tools.emails.editor.create',
                            label: 'messages.sitemap.tools.emails.editor.create',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-editor-create'
                        },
                        {
                            route: 'tools.emails.editor.edit',
                            label: 'messages.sitemap.tools.emails.editor.edit',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-editor-edit'
                        },
                        {
                            route: 'tools.emails.messenger-app.edit',
                            label: 'messages.sitemap.tools.emails.messenger_app.edit',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-messenger-app-edit'
                        }
                    ]
                },
                {
                    route: 'tools.emails.legal-info-index',
                    label: 'messages.sitemap.tools.emails.legal_info',
                    permissions: ['tool.emails_edit'],
                    showInSidebar: true,
                    id: 'tools-emails-legal-info-index',
                    children: [
                        {
                            route: 'tools.emails.legal-info-create',
                            label: 'messages.sitemap.tools.emails.legal_info',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-legal-info-create'
                        },
                        {
                            route: 'tools.emails.legal-info-edit',
                            label: 'messages.sitemap.tools.emails.legal_info',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-legal-info-edit'
                        }
                    ]
                },
                {
                    route: 'tools.emails.footer-links-index',
                    label: 'messages.sitemap.tools.emails.links',
                    permissions: ['tool.emails_edit'],
                    showInSidebar: true,
                    id: 'tools-emails-links-index',
                    children: [
                        {
                            route: 'tools.emails.footer-links-create',
                            label: 'messages.sitemap.tools.emails.links',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-links-create'
                        },
                        {
                            route: 'tools.emails.footer-links-edit',
                            label: 'messages.sitemap.tools.emails.links',
                            permissions: ['tool.emails_edit'],
                            showInSidebar: false,
                            id: 'tools-emails-links-edit'
                        }
                    ]
                },
                ...($page.props.tenantSettings.sms_communications
                    ? [
                        {
                            route: 'tools.sms-templates.index',
                            label: 'messages.sitemap.tools.sms_templates.index',
                            showInSidebar: true,
                            permissions: ['setting.sms'],
                            id: 'tools-sms-templates-index',
                            children: [
                                {
                                    route: 'tools.sms-templates.flavours',
                                    label: 'messages.sitemap.tools.sms_templates.flavours',
                                    permissions: ['setting.sms'],
                                    showInSidebar: false,
                                    id: 'tools-sms-templates-flavours'
                                },
                                {
                                    route: 'tools.sms-templates.create',
                                    label: 'messages.sitemap.tools.sms_templates.create',
                                    permissions: ['setting.sms'],
                                    showInSidebar: false,
                                    id: 'tools-sms-templates-create'
                                },
                                {
                                    route: 'tools.sms-templates.edit',
                                    label: 'messages.sitemap.tools.sms_templates.edit',
                                    permissions: ['setting.sms'],
                                    showInSidebar: false,
                                    id: 'tools-sms-templates-edit'
                                }
                            ]
                        }
                    ]
                    : [])
            ]
        },
        ...($page.props.environment.startsWith('prod')
            ? []
            : [
                {
                    route: '',
                    label: 'messages.sitemap.tools.testing.testing',
                    sidebarItemName: 'testing',
                    showInSidebar: true,
                    showSecondDropdown: true,
                    id: 'tools-testing',
                    children: [
                        {
                            route: 'tools.date_manipulation.index',
                            label: 'messages.sitemap.tools.testing.date_manipulation.date_manipulation',
                            showInSidebar: true,
                            id: 'tools-testing-date-manipulation'
                        },
                        {
                            route: 'tools.tenant.create',
                            label: 'messages.sitemap.tools.testing.tenant.add_tenant',
                            showInSidebar: true,
                            id: 'tools-testing-tenant-create'
                        },
                        {
                            route: 'tools.tenant.index',
                            label: 'messages.sitemap.tools.testing.tenant.delete_tenant',
                            showInSidebar: true,
                            id: 'tools-testing-tenant-delete'
                        },
                        {
                            route: 'tools.snapshot.index',
                            label: 'messages.sitemap.tools.testing.snapshot.index',
                            showInSidebar: true,
                            id: 'tools-testing-snapshot-apply'
                        },
                        {
                            route: 'tools.cli_commands.index',
                            label: 'messages.sitemap.tools.testing.cli_commands.cli_commands',
                            showInSidebar: true,
                            id: 'tools-testing-cli-commands-index'
                        },
                        {
                            route: 'tools.mocking.create',
                            label: 'messages.sitemap.tools.testing.mocking.title',
                            showInSidebar: true,
                            id: 'tools-testing-mocking-index'
                        },
                        {
                            route: 'tools.open-stack.index',
                            label: 'messages.sitemap.tools.testing.open-stack.cloud',
                            showInSidebar: true,
                            id: 'tools-testing-open-stack-index'
                        }
                    ]
                }
            ]
        )
    ]
}
